(function () {
  function initHelpCenter(root) {
    if (!root || root.dataset.hcInit === 'true') return;
    root.dataset.hcInit = 'true';

    root.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-help-center-toggle]');
      if (!toggle || !root.contains(toggle)) return;

      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var nextPanel = toggle.nextElementSibling;

      toggle.setAttribute('aria-expanded', String(!expanded));
      if (nextPanel) {
        if (expanded) {
          nextPanel.setAttribute('hidden', '');
        } else {
          nextPanel.removeAttribute('hidden');
        }
      }
    });

    var searchInput = root.querySelector('[data-help-center-search]');
    if (searchInput) {
      var noResults = root.querySelector('[data-help-center-no-results]');
      var debounceId = null;

      searchInput.addEventListener('input', function () {
        clearTimeout(debounceId);
        debounceId = setTimeout(function () {
          filterItems(root, searchInput.value, noResults);
        }, 100);
      });
    }
  }

  function filterItems(root, rawQuery, noResults) {
    var query = (rawQuery || '').trim().toLowerCase();
    var items = root.querySelectorAll('[data-help-center-item]');
    var subcategories = root.querySelectorAll('[data-help-center-subcategory]');
    var categories = root.querySelectorAll('.help-center__category');
    var anyVisible = false;

    items.forEach(function (item) {
      var matches = !query || (item.dataset.searchText || '').indexOf(query) !== -1;
      if (matches) {
        item.removeAttribute('hidden');
        anyVisible = true;
      } else {
        item.setAttribute('hidden', '');
      }
    });

    subcategories.forEach(function (sub) {
      var visibleItems = sub.querySelectorAll('[data-help-center-item]:not([hidden])');
      var content = sub.querySelector('.help-center__subcategory-content');
      var toggle = sub.querySelector('[data-help-center-toggle="subcategory"]');

      if (visibleItems.length === 0 && query) {
        sub.setAttribute('hidden', '');
      } else {
        sub.removeAttribute('hidden');
        if (query && content && toggle) {
          content.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
        }
      }
    });

    categories.forEach(function (cat) {
      var visibleSubs = cat.querySelectorAll('[data-help-center-subcategory]:not([hidden])');
      if (visibleSubs.length === 0 && query) {
        cat.setAttribute('hidden', '');
      } else {
        cat.removeAttribute('hidden');
      }
    });

    if (noResults) {
      if (!anyVisible && query) {
        noResults.removeAttribute('hidden');
      } else {
        noResults.setAttribute('hidden', '');
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-help-center]').forEach(initHelpCenter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var newRoot = event.target.querySelector('[data-help-center]');
    if (newRoot) initHelpCenter(newRoot);
  });
})();